import { useSetAtom } from "jotai";
import { useCallback } from "react";

import { ApiResponseError } from "@/apis/errors";
import { errorApiAtom } from "@/states/error/atoms";

export const useDisplayError = () => {
  const setErrorApi = useSetAtom(errorApiAtom);

  return useCallback(
    (error: ApiResponseError) => {
      setErrorApi((prev) => ({ ...prev, error: error }));
    },
    [setErrorApi],
  );
};

export const useClearError = () => {
  const setErrorApi = useSetAtom(errorApiAtom);

  return useCallback(() => {
    setErrorApi((prev) => ({ ...prev, error: undefined }));
  }, [setErrorApi]);
};
